import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/84ee525ef501495893a4d4a836c9dfd3.jpg',
      title: 'Palm Oil Excellence',
      subtitle: 'Drixem Mega Sdn Bhd – Premium Malaysian palm oil production and processing',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Automated%20cooking%20oil%20bottling%20production%20line%20with%20conveyor%20belt%20filling%20machines%20capping%20stations%20and%20labelling%20equipment%20in%20modern%20factory%20clean%20stainless%20steel%20machinery%20with%20bottles%20being%20filled%20with%20golden%20cooking%20oil%20bright%20industrial%20lighting%20professional%20manufacturing%20photography&width=1920&height=1080&seq=hero-filling-line-v2&orientation=landscape',
      title: 'Advanced Manufacturing',
      subtitle: 'Drixem Nexus Manufacturing Sdn Bhd – State-of-the-art production facilities',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20tropical%20residential%20property%20development%20with%20contemporary%20architecture%20lush%20green%20landscaping%20palm%20trees%20and%20swimming%20pool%20in%20Malaysian%20tropical%20setting%20warm%20golden%20hour%20sunlight%20professional%20real%20estate%20photography%20showing%20premium%20lifestyle%20living&width=1920&height=1080&seq=hero-realestate-my-v2&orientation=landscape',
      title: 'Property Development',
      subtitle: 'Heuliez (M) Sdn Bhd – Established since 1996, strategic property development',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Busy%20Malaysian%20port%20with%20cargo%20containers%20ships%20and%20cranes%20at%20Port%20Klang%20Malaysia%20showing%20international%20trade%20logistics%20and%20export%20operations%20with%20tropical%20sky%20and%20palm%20trees%20in%20background%20professional%20industrial%20port%20photography&width=1920&height=1080&seq=hero-export-my-v2&orientation=landscape',
      title: 'B2B Export Trade',
      subtitle: 'Aravion Zeus Sdn Bhd – Global trade hub connecting Malaysian products worldwide',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20Malaysian%20tech%20startup%20office%20with%20diverse%20Malay%20team%20working%20on%20computers%20showing%20software%20dashboard%20screens%20with%20data%20analytics%20and%20AI%20interface%20bright%20contemporary%20workspace%20with%20tropical%20plants%20professional%20technology%20office%20photography&width=1920&height=1080&seq=hero-tech-my-v2&orientation=landscape',
      title: 'Advertising, Marketing & Physical AI',
      subtitle: 'Drixem Sdn Bhd (MSC Status) & Nexa Prime Sdn Bhd – Physical AI integration and digital innovation',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>
      ))}

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <p className="text-base sm:text-xl md:text-2xl font-display text-accent-200 mb-3 italic">
            &ldquo;We Create Our Own Destiny&rdquo;
          </p>
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-4 leading-tight break-words">
            Drixem Group
          </h1>
          <p className="text-lg sm:text-2xl md:text-3xl font-display text-white/95 mb-4 leading-snug">
            Where Legacy Meets <strong>Physical AI</strong> — Your Gateway to High-Yield Returns
          </p>
          <p className="text-sm sm:text-base md:text-lg text-white/80 mb-4 max-w-3xl mx-auto leading-relaxed">
            A Malaysian business conglomerate integrating <strong>Physical AI</strong> with <strong>real-world business operations</strong> across <strong>Palm Oil</strong>, <strong>Manufacturing</strong>, <strong>Property Development</strong>, <strong>B2B Export Trade</strong>, <strong>Advertising &amp; Marketing</strong>, and <strong>AI IT Tech</strong> — powering a <strong>Closed-Loop Ecosystem</strong>
          </p>

          <div className="mb-8 min-h-[60px] flex flex-col items-center justify-center">
            <p className="text-lg sm:text-2xl md:text-3xl font-display font-semibold text-accent-200 transition-all duration-500">
              {slides[currentSlide].title}
            </p>
            <p className="text-xs sm:text-sm md:text-base text-white/70 mt-1">
              {slides[currentSlide].subtitle}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/investor-relations"
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base text-center"
            >
              Explore Investment Opportunities
            </Link>
            <Link
              to="/contact"
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg backdrop-blur-sm transition-all border border-white/30 whitespace-nowrap cursor-pointer text-sm sm:text-base text-center"
            >
              Partner With Us
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75 w-3'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
